import {
  CardDefinition,
  CAROUSEL,
  CarouselDefinition,
  QUIZ_CHOICE
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import { useEditorStore } from '~/shell/Store';

export const Multimedia4_Quiz: Translator = sequence => {
  const { contentEditable } = useEditorStore.getState();

  const cards: CardDefinition[] = [];
  let cardIndex = 1;
  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      cards.push(
        CardHelper(item as ItemOfType<'Question'>, {
          // height: contentEditable ? 'auto' : '500px',
          height: 'auto',
          width: '368px',
          padding: 0,
          align: 'left',
          type: 'li',
          extraType: 'ul',
          extraItems: [
            {
              id: `${item.id}.quiz`,
              type: QUIZ_CHOICE,
              values: {
                title: item?.title?.includes('?')
                  ? item.title
                  : item?.body?.includes('?')
                  ? item.body
                  : ''
              },
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                linkedAudioId: item.audios?.[0]?.id,
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        })
      );

      cardIndex++;
    }

    return null;
  });

  root.items.push({
    type: CAROUSEL,
    id: `${sequence.id}.carousel`,
    values: {
      variant: 'horizontal',
      showProgressBar: contentEditable ? false : true,
      clearQuizFeedbackOnChange: true,
      itemType: 'QUESTION',
      cssStylesForItem: !contentEditable
        ? undefined
        : {
            'place-self': 'flex-end',
            height: '90%'
          }
    },
    items: cards
  } as CarouselDefinition);

  return root;
};
